import { gql } from 'apollo-angular';

export const GlGraphqlQueries = {
  experienceListQuery: gql`
    query GetAllExperience($skip: Int, $take: Int) {
      getAllExperience(skip: $skip, take: $take) {
        experience {
          id
          name
          status {
            id
            is_active
            name
          }
          type {
            id
            name
          }
          venue {
            id
            name
            layout {
              id
              name
              functions {
                id
                name
                start_date
                end_date
                tickets {
                  id
                  seat_id
                }
              }
            }
          }
          url
        }
        total_count
      }
    }
  `,
  experienceSingleQuery: gql`
   query Query($experienceId: ID) {
    getExperience(id: $experienceId) {
        id
      name
      subtitle
      description
      synopsis
      url
      is_public
      ticket_title
      ticket_template {
        id
        name
        template
      }
      type {
        id
        name
      }
      country {
        id
        name
        abreviation
      }
      status {
        id
        name
        description
      }
      media {
        name
        is_active
        url
        id
        subcategory {
          id
          name
        }
      }
      payment_method_experience {
        id
        payment_method {
          id
          name
        }
      }
      allow_print
      season_unique
      venue {
        id
      }
      layout {
        id
      }
      terms_and_conditions {
        id
      }
    }
  }`,


  experienceListFilterPermissionQuery:  gql`
query getAllExperienceFilterPermission($skip: Int, $take: Int, $search: String, $statusId: Float) {
  getAllExperienceFilterPermission(skip: $skip, take: $take, search: $search, status_id: $statusId) {
    experience {
      id
      name
      status {
        id
        is_active
        name
      }
      type {
        id
        name
      }
      venue {
        id
        name
        layout {
          id
          name
          functions {
            id
            name
            start_date
            end_date
            tickets {
              id
              seat_id
            }
          }
        }
      }
      url
      user_experience {
        user_experience_role {
          role {
            name
          }
          profile {
            profile_role {
              role {
                name
              }
            }
          }
        }
      }
      media {
        url
          is_active
        subcategory {
          id
          name
          is_active
        }
        name
      }
    }
    total_count
    user_profile {
      profile {
        name
        id
        profile_role {
          role {
            name
          }
        }
      }
    }
  }
}
`,
  experienceTypesListQuery: gql`
    query {
      getAllExperienceType {
        id
        name
        description
      }
    }
  `,
  experienceStatusListQuery: gql`
    query {
      getAllExperienceStatus {
        id
        name
        description
      }
    }
  `,
  ticketTemplateListQuery: gql`
    query {
      getAllTicketTemplate {
        id
        name
      }
    }
  `,
  seasonsExperienceListQuery: gql`
    query GetSeasonsExperience($experienceId: Int!, $skip: Int, $take: Int) {
      getSeasonsExperience(
        experience_id: $experienceId
        skip: $skip
        take: $take
      ) {
        total_count
        seasons_experience {
          id
          name
          url
        }
      }
    }
  `,
  allSeasonExperienceListQuery: gql`
    query GetSeasonsExperience($experienceId: Int!) {
      getSeasonsExperience(experience_id: $experienceId) {
        seasons_experience {
          id
          name
        }
      }
    }
  `,
  seasonSingleQuery: gql`
    query GetSeason($seasonId: ID!) {
      getSeason(id: $seasonId) {
        id
        name
        slogan
        description
        url
        start_date
        end_date
        status {
          id
          name
        }
      }
    }
  `,
  functionsExperienceListQuery: gql`
    query GetFunctionsExperience(
      $experienceId: Int!
      $skip: Int
      $take: Int
      $where: ArgsFunctionsExperienceDto!
    ) {
      getFunctionsExperience(
        experience_id: $experienceId
        skip: $skip
        take: $take
        where: $where
      ) {
        total_count
        functions_experience {
          id
          name
          port_code
          start_date
          season {
            id
            name
          }
        }
      }
    }
  `,
  seasonsExperience: gql`
    query GetSeasonsExperience($experienceId: Int!, $take: Int) {
      getSeasonsExperience(experience_id: $experienceId, take: $take) {
        seasons_experience {
          id
          name
          start_date
          end_date
          url
          status {
            id
            name
          }
          functions {
            id
            name
            eventkey
            start_date
            end_date
            sale_closing_date
            port_code
            layout {
              id
              name
              chartkey
              map_type {
                id
                name
              }
            }
            function_zone {
              id
              zone_name
              capacity
              zone {
                id
                name
                capacity
                by_category_key
                seats_io_zone_color
              }
            }
            payment_pricing_zone {
              id
              ticket_price
              zone {
                id
                is_active
                capacity
                name
                by_category_key
              }
              pricing {
                id
              }
            }
            promotion_function_pricing {
              id
              is_active
              function {
                id
                name
              }
              pricing {
                id
                name
              }
              is_active
              promotion {
                id
                promotion_name
                promotion_type {
                  id
                  name
                  is_active
                }
                minimun_quantity_ticket
                individual_inventory
                how_often
                fixed_discount
                attemps_per_user
                attemps
                is_public
                percent_discount
                ticket_name
                is_active
                start_date
                end_date
              }
            }
          }
        }
      }
    }
  `,
  venueListQuery: gql`
    query GetVenues($skip: Int, $take: Int) {
      getAllVenue(skip: $skip, take: $take) {
        total_count
        venue {
          id
          name
          description
          is_public
          media {
            id
            name
            url
            subcategory {
              name
              id
            }
          }
          layout {
            functions {
              start_date
              end_date
              season {
                experience {
                  id
                  name
                }
                start_date
                end_date
              }
            }
          }
        }
      }
    }
  `,
  allVenueListQuery: gql`
    query Venue {
      getAllVenue {
        venue {
          id
          name
        }
      }
    }
  `,
  getAllVenueLayoutsZones: gql`
    query GetVenue($getVenueId: ID!) {
      getVenue(id: $getVenueId) {
        id
        name
        layout {
          id
          name
          zone {
            id
            name
            capacity
            by_category_key
            seats_io_zone_color
          }
          seats_io_thumbnail
        }
      }
    }
  `,
  venueTypesListQuery: gql`
    query {
      getAllVenueType {
        venue_type {
          id
          name
          description
        }
      }
    }
  `,
  venueSingleQuery: gql`
    query GetVenue($venueId: ID!) {
      getVenue(id: $venueId) {
        id
        name
        description
        type {
          id
          name
        }
        url
        is_public
        email
        phone
        website
        full_address
        city {
          id
          name
        }
        latitude
        longitude
        layout {
          id
          name
          is_active
          capacity
          zone {
            id
          }
          functions {
            id
          }
          map_type {
            id
            name
          }
        }
        media {
          id
          name
          is_active
          url
          subcategory {
            name
            id
          }
        }
      }
    }
  `,
  layoutSingleQuery: gql`
    query GetLayout($layoutId: ID!) {
      getLayout(id: $layoutId) {
        id
        name
        capacity
        chartkey
        description
        url
        is_active
        seats_io_thumbnail
        zone {
          id
          name
          is_active
          capacity
          by_category_key
          seats_io_zone_color
        }
        map_type {
          id
          name
        }
      }
    }
  `,
  profileListQuery: gql`
    query Profile($skip: Int, $take: Int) {
      getAllProfile(skip: $skip, take: $take) {
        profile {
          id
          name
          description
          module_count
          user_count
        }
        total_count
      }
    }
  `,
  profileListAllQuery: gql`
    query GetAllProfile($skip: Int, $take: Int) {
      getAllProfile(skip: $skip, take: $take) {
        profile {
          id
          name
          description
          profile_role {
            id
            role {
              id
              is_active
            }
          }
        }
        total_count
      }
    }
  `,
  getAllUser: gql`
    query GetAllUser($skip: Int, $take: Int) {
      getAllUser(skip: $skip, take: $take) {
        total_count
        user {
          id
          email
          name
          last_name
          photo
          is_goliiive
          is_blocked
          is_active
          is_verified
          payment {
            id
          }
          country {
            name
            id
            abreviation
          }
        }
      }
    }
  `,
  getAllUserFilter: gql`
  query GetAllUser($skip: Int, $take: Int, $search: String) {
    getAllUserWithSearch(skip: $skip, take: $take,search: $search) {
      total_count
      user {
        id
        email
        name
        last_name
        photo
        is_goliiive
        is_blocked
        is_active
        is_verified
        payment {
          id
        }
        country {
          name
          id
          abreviation
        }
      }
    }
  }
`,
  getAllCountry: gql`
    query GetAllCountry {
      getAllCountry {
        id
        name
        city {
          id
          name
        }
      }
    }
  `,
  getAllFunctionStatus: gql`
    query GetAllFunctionStatus {
      getAllFunctionStatus {
        id
        name
      }
    }
  `,
  getAllPaymentsFunctionExperience: gql`
    query GetAllPaymentsFuntionExperience(
      $functionId: ID
      $skip: Int
      $take: Int
    ) {
      getAllPaymentsFunctionExperience(
        function_id: $functionId
        skip: $skip
        take: $take
      ) {
        total_count
        payments_experience {
          id
          amount
          last_four_digits
          status {
            id
            name
          }
          ticket {
            id
            seat_id
            sent_attempts
            is_used
            is_sent
            is_printed
            user_name
            user_email
            code
            price
            ticket_type {
              id
              name
            }
            zone {
              id
              name
              seats_io_zone_color
            }
            exit_control {
              id
              is_in_event
              is_out_event
            }
            function {
              start_date
              layout {
                venue {
                  name
                }
              }
              currency_function {
                currency {
                  description
                  symbol
                }
              }
            }
            payment {
              amount
              payment_detail {
                amount
                payment_detail_type {
                  name
                  code
                }
              }
            }
          }
          user {
            id
            email
            name
            last_name
            photo
          }
          created_at
        }
      }
    }
  `,
  getPayment: gql`
    query GetPayment($paymentId: ID) {
      getPayment(payment_id: $paymentId) {
        id
        amount
        last_four_digits
        status {
          id
          name
        }
        ticket {
          id
          seat_id
          sent_attempts
          is_used
          is_sent
          is_printed
          user_name
          user_email
          code
          price
          ticket_type {
            id
            name
          }
          zone {
            id
            name
            seats_io_zone_color
          }
          exit_control {
            id
            is_in_event
            is_out_event
          }
          function {
            start_date
            layout {
              venue {
                name
              }
            }
            currency_function {
              currency {
                description
                symbol
              }
            }
          }
          payment {
            amount
            payment_detail {
              amount
              payment_detail_type {
                name
                code
              }
            }
          }
        }
        user {
          id
          email
          name
          last_name
          photo
        }
        created_at
      }
    }
  `,
  AllModule: gql`
    query {
      getAllModule {
        role {
          id
          name
          is_active
        }
        id
        name
        description
        is_active
      }
    }
  `,
  profileSingleQuery: gql`
    query Profile($id: Int!) {
      getProfile(id: $id) {
        profile {
          id
          name
          description
          profile_role {
            id
            role {
              id
              is_active
            }
          }
        }
      }
    }
  `,
  princingListQuery: gql`
    query GetAllPricingExperience($experienceId: Int!, $skip: Int, $take: Int) {
      getAllPricingExperience(
        experience_id: $experienceId
        skip: $skip
        take: $take
      ) {
        total_count
        pricing {
          id
          name
          ticket_price
          terms_and_conditions {
            id
            name
          }
        }
      }
    }
  `,
  princingSingleQuery: gql`
    query GetPricing($getPricingId: ID!) {
      getPricing(id: $getPricingId) {
        id
        name
        goliiive_comission
        goliiive_iva
        goliiive_net
        goliiive_tax_base
        production_income
        production_iva
        production_municipal_tax
        production_net
        production_tax_base
        ticket_price
        pricing_input {
          id
          goliiive_percent_comission
          is_active
          iva
          municipal_tax
          production_net
          production_price
          ticket_price
        }
        terms_and_conditions {
          id
          name
        }
        comission_type_id
      }
    }
  `,
  getAllPricingExperience: gql`
    query GetAllPricingExperience($experienceId: Int!) {
      getAllPricingExperience(experience_id: $experienceId) {
        pricing {
          id
          name
          ticket_price
          terms_and_conditions {
            id
            name
          }
        }
      }
    }
  `,
  termsConditionsListQuery: gql`
    query GetAllTermsAndConditions {
      getAllTermsAndConditions {
        terms_and_conditions {
          id
          name
        }
      }
    }
  `,
  promotionTypes: gql`
    query GetPromotionTypes {
      getPromotionTypes {
        id
        name
      }
    }
  `,
  getAllPromotionsFunctionExperience: gql`
    query GetAllPromotionsExperience(
      $experienceId: Int!
      $skip: Int
      $take: Int
    ) {
      getAllPromotionsExperience(
        experience_id: $experienceId
        skip: $skip
        take: $take
      ) {
        promotion {
          is_active
          promotion_name
          delete_date
          promotion_code
          end_date
          start_date
          id
        }
        total_count
      }
    }
  `,
  getAllPromotionsFunctionExperienceAllData: gql`
    query Promotion($experienceId: Int, $functionId: Int) {
      getAllPromotionsFunctionExperience(
        experience_id: $experienceId
        function_id: $functionId
      ) {
        promotion {
          id
          promotion_name
          individual_inventory
          global_inventory
          percent_discount
          fixed_discount
          promotion_code
          attemps
          attemps_per_user
          minimun_quantity_ticket
          how_often
          start_date
          end_date
          is_active
          created_at
          delete_date
          is_public
          slug
          ticket_name
          function_name
          terms_and_conditions {
            id
            name
            terms_and_conditions
            is_active
            created_at
            created_by
            updated_at
            updated_by
            delete_date
          }
          promotion_function_pricing {
            id
            function_inventory
            pricing_inventory
            is_active
            created_at
            delete_date
          }
          experience {
            id
            name
            description
            url
            transaction_id
            start_date
            end_date
            is_active
            created_at
            created_by
            updated_at
            updated_by
            delete_date
            is_public
            synopsis
          }
        }
      }
    }
  `,
  getPromotionsFunctionExperience: gql`
    query GetPromotion($getPromotionId: ID!) {
      getPromotion(id: $getPromotionId) {
        promotion_type {
          id
        }
        promotion_name
        global_inventory
        percent_discount
        promotion_code
        attemps
        attemps_per_user
        how_often
        start_date
        end_date
        is_public
        slug
        ticket_name
        function_name
        terms_and_conditions {
          id
        }
        id
        promotion_function_pricing {
          id
          pricing {
            id
            name
          }
          pricing_inventory
          function_inventory
          function {
            id
            name
          }
          is_active
        }
      }
    }
  `,
  GetPricingFunctionIn: gql`
    query GetPricingFunctionIn($functions: [Float!]!) {
      getPricingFunctionIn(functions: $functions) {
        ticket_price
        name
        id
        is_active
        terms_and_conditions {
          id
          name
        }
      }
    }
  `,
  getUserExperienceByExperience: gql`
    query GetUserExperienceByExperience(
      $experienceId: Int!
      $take: Int
      $skip: Int
    ) {
      getUserExperienceByExperience(
        experience_id: $experienceId
        take: $take
        skip: $skip
      ) {
        user_experience {
          id
          user {
            id
            name
            photo
            last_name
            email
          }
          is_active
          created_at
        }
        total_count
      }
    }
  `,
  getMediasExperience: gql`
    query GetMediasExperience($experienceId: ID!) {
      getMediasExperience(experience_id: $experienceId) {
        is_active
        id
        url
        name
        subcategory {
          id
        }
      }
    }
  `,
  GetUser: gql`
    query GetUser($where: ArgsUserDto!) {
      getUser(where: $where) {
        id
        name
        last_name
        email
        is_active
        photo
        user_address {
          id
          full_address
        }
        user_contact {
          id
          description
          is_main
        }
        user_information {
          id
          information_type {
            id
            name
            description
          }
        }
        user_profile {
          profile {
            id
            name
          }
          id
        }
        country {
          id
          city {
            country {
              id
              name
            }
            name
          }
          name
        }
      }
    }
  `,
  GetUserStep: gql`
    query GetUser($where: ArgsUserDto!) {
      getUser(where: $where) {
        name
        last_name
        email
        is_active
        photo
      }
    }
  `,
  getAllSeasonStatus: gql`
    query Query {
      getAllSeasonStatus {
        id
        name
        is_active
      }
    }
  `,
  experienceSingleBySlugQuery: gql`
    query Query($slug: String) {
      getExperience(slug: $slug) {
        id
        name
        subtitle
        description
        synopsis
        url
        is_public
        allow_print
        ticket_title
        ticket_template {
          id
          name
          template
        }
        type {
          id
          name
        }
        country {
          id
          name
          abreviation
          city {
            name
            abreviation
          }
        }
        status {
          id
          name
          description
        }

        media {
          name
          is_active
          url
          id
          subcategory {
            id
            name
          }
        }
        promotion {
          id
          promotion_name
          promotion_type {
            id
            name
            is_active
          }
          minimun_quantity_ticket
          individual_inventory
          how_often
          fixed_discount
          attemps_per_user
          attemps
          is_public
          percent_discount
          ticket_name
          is_active
          start_date
          end_date
          promotion_function_pricing {
            function {
              id
              name
              payment_pricing_zone {
                pricing {
                  id
                  name
                }
              }
            }
            pricing {
              id
              name
            }
            is_active
          }
        }
        season {
          is_active
          functions {
            eventkey
            name
            id
            start_date
            end_date
            duration
            is_public
            layout {
              chartkey
              capacity
            }
            payment_pricing_zone {
              id
              pricing {
                id
                name
                ticket_price
                is_active
                terms_and_conditions {
                  id
                  name
                  terms_and_conditions
                  is_active
                }
                promotion_function_pricing {
                  id
                  function_inventory
                  is_active
                  pricing_inventory
                  promotion {
                    id
                    promotion_name
                    promotion_type {
                      id
                      name
                      is_active
                    }
                    minimun_quantity_ticket
                    individual_inventory
                    how_often
                    fixed_discount
                    attemps_per_user
                    attemps
                    is_public
                    percent_discount
                    ticket_name
                    is_active
                    start_date
                    end_date
                  }
                }
                comission_type_id
                goliiive_comission
                pricing_input {
                  goliiive_percent_comission
                  ticket_price
                }
                goliiive_net
              }
              zone {
                function_zone {
                  id
                }
                capacity
                id
                name
                seats_io_zone_color
                by_category_key
              }
            }
            payment_method_function {
              payment_method {
                id
                name
                is_active
                currency {
                  id
                  name
                }
                sale_channel_id
              }
            }
          }
        }
      }
    }
  `,
  getPricingFunctionInPublic: gql`
    query Promotion_function_pricing($functions: [Float!]!) {
      getPricingFunctionIn(functions: $functions) {
        ticket_price
        name
        id
        is_active
        terms_and_conditions {
          id
          name
        }
        promotion_function_pricing {
          id
          promotion {
            promotion_type {
              id
              name
              is_active
            }
            ticket_name
            promotion_name
            individual_inventory
            global_inventory
            fixed_discount
            percent_discount
            minimun_quantity_ticket
            attemps
            attemps_per_user
            how_often
            end_date
            is_active
            is_public
            id
          }
          function {
            name
            function_zone {
              zone_name
              id
              is_active
            }
          }
        }
      }
    }
  `,
  getFunctionsById: gql`
    query GetFunction($functionId: ID!) {
      getFunction(function_id: $functionId) {
        name
        description
        allow_send_ticket
        allow_print_ticket
        start_date
        end_date
        capacity
        duration
        sale_closing_date
        start_date
        end_date
        sale_closing_date
        is_public
        allow_send_ticket
        allow_print_ticket
        season {
          id
        }
        status {
          id
        }
        layout {
          id
          venue {
            id
          }
          zone {
            capacity
            id
            name
            seats_io_zone_color
          }
        }
      }
    }
  `,
  getPaymentMethodsExperience: gql`
    query GetPaymentMethodsExperience($experienceId: ID!) {
      getPaymentMethodsExperience(experience_id: $experienceId) {
        id
        payment_method {
          id
          name
          currency {
            id
            name
          }
        }
        is_active
        payment_configuration
      }
    }
  `,
  getPaymentMethodsExperienceAndgetAllPaymentMethod: gql`
    query GetPaymentMethodsExperience($experienceId: ID!) {
      getPaymentMethodsExperience(experience_id: $experienceId) {
        id
        payment_method {
          id
          name
        }
        is_active
        payment_configuration
      }
      getAllPaymentMethod {
        payments_methods {
          id
          name
          is_active
        }
      }
    }
  `,
  GetFunctionsZonesExperience: gql`
    query GetFunctionsZonesExperience($functionId: Int!) {
      getFunctionsZonesExperience(function_id: $functionId) {
        name
        description
        is_public
        url
        allow_send_ticket
        allow_print_ticket
        start_date
        end_date
        capacity
        duration
        sale_closing_date
        special_taxpayer
        season {
          id
        }
        status {
          id
        }
        layout {
          id
          venue {
            id
          }
        }
        function_zone {
          id
          zone {
            id
            function_zone {
              capacity
            }
          }
        }
        payment_pricing_zone {
          id
          pricing {
            id
            name
            ticket_price
            is_active
            terms_and_conditions {
              id
            }
          }
          zone {
            id
            function_zone {
              id
            }
          }
        }
        payment_method_function {
          payment_method {
            id
            name
          }
          is_active
          id
          payment_configuration
        }
      }
    }
  `,
  GetProfilesByUser: gql`
    query Profile($where: ArgsUserDto!, $userId: Int!) {
      getUser(where: $where) {
        email
        name
        last_name
        is_goliiive
        is_blocked
        is_active
      }
      getProfilesByUser(userId: $userId) {
        profile {
          id
          name
          is_active
        }
      }
    }
  `, gerUserExperiencesEsencial: gql`
    query GetUserExperience($userId: Int!) {
      getUserExperience(user_id: $userId) {
        total_count
        user_experience {
          experience {
            id
          }
        }
      }
    }
  `,
  getUserEdit: gql`
  query GetUserEdit($where: ArgsUserDto!) {
  getUser(where: $where) {
    email
    id
    is_goliiive
    created_by
    created_at
    name
    photo
    last_name
    country {
      id
    }
    user_address {
      full_address
      is_main
      is_active
    }
    user_information {
      description
      information_type {
        country {
          id
        }
      }
      is_active
    }
    user_contact {
      contact_type {
        id
      }
      description
      is_active
      is_main
    }
    is_active
    is_blocked
  }
}`

};
